import React from "react";
import "./Facilities.scss";
import clubhouse from "../../Assets/Facilities/Facilities (1).jpg";
import joggingtrack from "../../Assets/Facilities/Facilities (2).jpg";
import civiccenter from "../../Assets/Facilities/Facilities (3).jpg";
import breeze from "../../Assets/Facilities/Facilities (4).jpg";
import qbig from "../../Assets/Facilities/Facilities (5).jpg";
import eka from "../../Assets/Facilities/Facilities (6).jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Facilities = () => {
  const slides = [
    { src: clubhouse, des: "Futsal Court" },
    { src: joggingtrack, des: "Tennis Court" },
    { src: civiccenter, des: "Park" },
    { src: breeze, des: "Golf Court" },
    { src: qbig, des: "Chapel" },
    { src: eka, des: "Clubhouse" },
  ];
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    lazyLoad: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <section className="surroundingcontainer" id="fasilitas">
      <div className="title">FACILITIES</div>
      <div className="content">
        {slides.map((slide, index) => (
          <div className="center" key={index}>
            <img className="imgcontent" src={slide.src} alt="Surrounding" />
            <div className="imgdes">
              <span>{slide.des}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="content1">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div className="center" key={index}>
              <img className="imgcontent" src={slide.src} alt="Surrounding" />
              <div className="imgdes">
                <span>{slide.des}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Facilities;
